export default "__VITE_ASSET__0b772281__"